import Vue from 'vue';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/en';
import 'dayjs/locale/id';
import store from '@/store';

const { locale } = store.state;
dayjs.locale(locale);
dayjs.extend(relativeTime);

Object.defineProperties(Vue.prototype, {
  $day: {
    get() {
      return dayjs;
    },
  },
});
